import React from 'react';
import styles from './VerifiedBlock.module.scss';
import { Icon, Tooltip } from 'antd';
import cn from 'classnames';

const VerifiedBlock = ({ isVerified, rootClassName, ...props }) => {
  return (
    <div className={cn(styles.root, rootClassName)}>
      <Tooltip
        title={isVerified ? 'Подтвержден' : 'Не подтвержден'}
        placement="topLeft"
      >
        {isVerified ? (
          <Icon
            type="check-circle"
            style={{ color: '#0995ED', fontSize: 20 }}
          />
        ) : (
          <Icon
            type="close-circle"
            style={{ color: '#F93336', fontSize: 20 }}
          />
        )}
      </Tooltip>
    </div>
  );
};

export default VerifiedBlock;
